import { render } from "./issue.vue?vue&type=template&id=7f51a123&ts=true"
import script from "./issue.vue?vue&type=script&lang=ts"
export * from "./issue.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__